module.exports = __webpack_public_path__ + "img/banner_ssc_chongqing.afe0b31b.jpg";